<template>
    <div>
         <div class="comp-info">
            <div class="tz-bold"> >>{{ competition.name }}--{{ currentStage.name }}--证券投资赛项 </div>
            <div class="member-info"> 
                <div>
                    <b-img src="/static/image/system_icon11.png"/> 
                    <span> 欢迎</span>
                    <span>{{ userInfo? userInfo.name: ''}}</span>
                </div>  
                <div>
                    <b-img src="/static/image/system_icon12.png" />
                    <span>退出</span>
                </div> 
            </div>
        </div>
        <div class="portrait">
            <div class="portrait_header">
                <div >
                    <b-img src="/static/image/portrait_icon1.png" />
                    <span>金融产品前十大持仓金额</span>
                </div>
                <div id="position"  style="width:100%; height:100%" ></div>
            </div>

            <div class="portrait_header">
                <div>
                    <b-img src="/static/image/portrait_icon2.png" />
                    <span>收益趋势</span>
                </div>
                <div id="profit" style="width:100%; height:100%"></div>
            </div>

            <div class="portrait_header">
                <div>
                    <b-img src="/static/image/portrait_icon3.png" />
                    <span>重仓情况</span>
                </div>
                <div style="width:100%; height:100%" class="tz-table">
                    <div>
                        <div class="table-header">
                            <div>
                                代码
                            </div>
                            <div>
                                名称
                            </div>
                            <div>
                                占比
                            </div>
                            <div>
                                日均持仓(股)
                            </div>
                            <div>
                                增减仓
                            </div>
                        </div>
                    </div>
                    <div class="table-content">
                       <div class="table-row" v-for="(item,$index) in heavyList" :key="$index">
                            <div>{{ item.code}}</div>
                            <div>{{ item.name}}</div>
                            <div>{{ item.ratio}}</div>
                            <div>{{ item.stocks}}</div>
                            <div>{{ item.direct}}</div>
                        </div>
                    </div>
                </div>
            </div>

             <div class="portrait_header">
                <div>
                    <b-img src="/static/image/portrait_icon4.png" />
                    <span>仓位配置</span>
                </div>
                <div id="heavy" style="width:100%; height:100%"></div>
            </div>

            <div class="portrait_header">
                <div>
                    <b-img src="/static/image/portrait_icon5.png" />
                    <span>调仓前投资组合</span>
                </div>
                <div id="invest" style="width:100%; height:100%"></div>
            </div>
            <div class="portrait_header">
                <div>
                    <b-img src="/static/image/protailt_icon6.png" />
                    <span>调仓后投资组合</span>
                </div>
                <div id="investAfter" style="width:100%; height:100%"></div>
            </div>
            <div class="portrait_header">
                <div>
                    <b-img src="/static/image/portrait_icon7.png" />
                    <span>交易次数</span>
                </div>
                <div id="tradeCount" style="width:100%; height:100%"></div>
            </div>
             <div class="portrait_header">
                <div>
                    <b-img src="/static/image/portrait_icon8.png" />
                    <span>持股时间</span>
                </div>
                <div style="width:100%; height:100%" class="tz-table">
                        <div>
                            <div class="table-header">
                                <div>
                                    股票
                                </div>
                                <div>
                                    代码
                                </div>
                                <div>
                                    持有时间（天）
                                </div>
                            </div>
                        </div>
                        <div class="table-content">
                            <div class="table-row" v-for="(item,$index) in holdList" :key="$index">
                                <div>{{ item.name}}</div>
                                <div>{{ item.code}}</div>
                                <div>{{ item.days}}</div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { getInfo } from '@/utils/auth'
import * as rankApi from '@/api/ranking'
import * as competitionApi from '@/api/competition'
export default {
    props:{
        compId:{
            type: Number,
            default: 0
        },
        stageId:{
            type: Number,
            default: 0
        },
        competition:{
            type: Object,
            default: null
        },
        currentStage:{
            type:Object,
            default: null
        },
        memberInfo:{
            type:Object,
            default: null
        }
    },
    data(){
        return {
            userInfo: null,
            positionCharts: null,
            profitCharts: null,
            heavyCharts: null,
            investCharts: null,
            investAfterCharts: null,
            tradeCountCharts: null,
            positionList: [],
            tenPosition:[],
            totalAmount:0,
            heavyList: [                
            ],
            holdList: [
            ],
            beforeStock:[],
            afterStock:[]
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.draw() 
            this.drawProfit()
            this.drawHeavy()
            this.drawInvest()
            this.drawInvestAfter()
            
            if(!!this.memberInfo&&!!this.memberInfo.reportId){
                 competitionApi.reportDetail(this.memberInfo.reportId).then(res=>{
                     this.drawTradeCount(res.data)
                 })
            }
        })
      this.userInfo = getInfo()
      competitionApi.positionAll({
          compId: this.compId,
          stageId: this.stageId
      }).then(res=>{
          if(res.code == 200){
              this.positionList = res.data;
              let tmp = this.positionList.filter(p=> p.hasOwnProperty('available'))

               tmp.forEach(p=>{
                  let ds = 0
                  if(p.hasOwnProperty("available_now")){
                     ds = this.getDay(p.created_at,null)
                  }else{
                      ds = this.getDay(p.created_at,p.updateTime)
                  }
                  let hold = {
                    name: p.sec_name,
                    code: p.symbol,
                    days: ds
                  }
                  this.holdList.push(hold)
                  this.totalAmount += p.market_value
              })

              
              tmp.sort(function(a,b){
                  let compare= new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
                  if(compare>0){
                      return 1
                  }else if(compare<0){
                      return -1
                  }else{
                      return 0
                  }
              })

              if(tmp.length>10){
                  this.beforeStock = tmp.slice(tmp.length-10,tmp.length)
              }else{
                  this.beforeStock = tmp
              }
              this.drawInvest()

              tmp.sort(function(a,b){
                  let compare= new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime()
                  if(compare>0){
                      return 1
                  }else if(compare<0){
                      return -1
                  }else{
                      return 0
                  }
              })

              if(tmp.length>10){
                  this.afterStock = tmp.slice(tmp.length-10,tmp.length)
              }else{
                  this.afterStock = tmp
              }
              this.drawInvestAfter()
              
              tmp.sort(function(a,b){
                  let rs =  b.market_value - a.market_value
                  if(rs>0){
                      return 1
                  }else if(rs<0){
                      return -1
                  }else{
                      return 0
                  }
              })
              

              if(tmp.length>10){
                  this.tenPosition = tmp.slice(0,10)
              }else{
                  this.tenPosition = tmp
              }
              this.tenPosition.forEach(p=>{
                  let status = ""
                  if(p.hasOwnProperty("available_now")&&p.available_now==0){
                      status = "新进"
                  }
                  let heavy = {
                    code: p.symbol,
                    name: p.sec_name,
                    ratio: (p.market_value/this.totalAmount*100).toFixed(2)+"%",
                    stocks: p.volume,
                    direct: status
                }
                  this.heavyList.push(heavy)
              })
              this.draw()
          }
      })
    },
    methods:{
        draw(){
            let xData = []
            let yData = []
            this.tenPosition.forEach(p=>{
                xData.push(p.sec_name)
                yData.push(p.market_value)
            })
            let positionOption = {            
            xAxis: {
                type: 'category',
                data: xData
            },
            yAxis: {
                type: 'value'                
            },
            series: [
                {
                data: yData,
                type: 'bar',
                color: '#3ea4f2'
                }
            ]
            }
            if(!this.positionCharts){
                this.positionCharts = echarts.init(document.getElementById("position"))
            }
          
           this.positionCharts.setOption(positionOption,true)
        },
        getDay(start,end){
            let s = new Date(start).getTime()
            let e = new Date().getTime()
            if(end){
                e = new Date(end).getTime()
            }
            var total = (e - s)/1000
            return parseInt(total / (24*60*60))
        },
        drawProfit(){
            rankApi.listWeek(this.compId,this.stageId).then(res=>{
                if(res.code == 200){
                    let xData = []
                    let yData = []
                    let yData2= []
                    for(let i = 0;i<res.data.list.length;i++){
                        let item = res.data.list[i]
                        xData.push(item.updateTime)
                        yData.push( (item.baseRatio*100).toFixed(2))
                        yData2.push( (item.pnlRatio*100).toFixed(2))
                    }
                    let  option = {
                            tooltip: {
                                trigger: 'axis',
                                textStyle:{
                                    align:'left'
                                },
                                formatter: function (params) {
                                    
                                    var html = params[0].axisValue+"<br/>"
                                    for(var i=0;i<params.length;i++){
                                        html+= params[i].marker+ params[i].seriesName+":"+params[i].value+"%<br/>"                      
                                    }
                                    return html;
                                }
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: false,
                                data: xData
                            },
                            yAxis: {
                                type: 'value',
                                 axisLabel: {  
                                    show: true,  
                                    interval: 'auto',  
                                    formatter: '{value} %'  
                                },
                            },
                            series: [
                                {
                                    name: '基准收益率',
                                    data: yData,
                                    type: 'line',
                                    areaStyle: {
                                        color: "#daf7f0"
                                    },
                                },
                                {
                                    name: '个人收益率',
                                    data: yData2,
                                    type: 'line',
                                    areaStyle: {
                                        color: "#daf7f0"
                                    },
                                }
                            ]
                        }
                    if(!this.profitCharts){
                        this.profitCharts = echarts.init(document.getElementById('profit'))
                    }
                    this.profitCharts.setOption(option)  
                }
            })
                    

        },
        drawHeavy(){
            let option = {
                
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                    name: '仓位配置',
                    type: 'pie',
                    radius: '50%',
                    data: [
                        { value: (this.memberInfo.totalFounds - this.memberInfo.availableFounds).toFixed(2), name: '当前仓位' },
                        { value: this.memberInfo.availableFounds, name: '可用资金'}
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                    }
                ]
                }
           if(!this.heavyCharts){
               this.heavyCharts = echarts.init(document.getElementById('heavy'))
           }
           this.heavyCharts.setOption(option) 
        },
        drawInvest(){

            let yData = []

            this.beforeStock.forEach(p=>{
                yData.push({
                    value: p.market_value.toFixed(2),
                    name: p.sec_name
                })
            })

            let option = {
                
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                    name: '投资组合',
                    type: 'pie',
                    radius: '50%',
                    data: yData,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                    }
                ]
                }
           if(!this.investCharts){
               this.investCharts = echarts.init(document.getElementById('invest'))
           }
           this.investCharts.setOption(option) 
        },
        drawInvestAfter(){
              let yData = []

            this.afterStock.forEach(p=>{
                yData.push({
                    value: p.market_value.toFixed(2),
                    name: p.sec_name
                })
            })
            let option = {
                
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                    name: '投资组合',
                    type: 'pie',
                    radius: '50%',
                    data: yData,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                    }
                ]
                }
           if(!this.investAfterCharts){
               this.investAfterCharts = echarts.init(document.getElementById('investAfter'))
           }
           this.investAfterCharts.setOption(option) 
        },
        drawTradeCount(data){
            if(!data){
                return
            }
            let yData=[]
            let xData=[]
            if(data.hasOwnProperty("orders")){
                let orders = data["orders"]
                let needList =  orders.filter(item=>{
                     return item["status"]==3
                })
       
                needList.sort((a,b)=>{
                    let c1 = new Date(a.created_at).getTime()
                    let c2 = new Date(b.created_at).getTime()
                    return c1-c2
                })
                const m = new Map()
                needList.forEach(item=>{
                    let day =  new Date(item.created_at).Format("yyyy/MM/dd")
                    if(m.has(day)){
                        m.set(day,m.get(day)+1)
                    }else{
                        m.set(day,1)
                    }
                })

           
                let startD = ''
                let endD = ''
                let total = 0
                let lastEndD = ''
                m.forEach((v,k)=>{
                    total+=v
                    lastEndD=k
                    let wd = new Date(k).getDay()                    
                    if(startD.length==0){
                        startD = k
                    }
                    if(wd==5){
                        endD = k
                        let tmp = startD+"-"+endD
                        yData.push(tmp)
                        xData.push(total)
                        total=0
                        startD= ''
                        endD=''
                    }                    
                })
                if(endD.length==0&&total>0){
                    let tmp = startD+"-"+lastEndD
                    yData.push(tmp)
                    xData.push(total)
                }
            }

            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: yData
                },
                series: [
                    {
                    type: 'bar',
                    data: xData
                    }
                ]
                };
           if(!this.tradeCountCharts){
               this.tradeCountCharts = echarts.init(document.getElementById('tradeCount'))
           }
           this.tradeCountCharts.setOption(option) 
        }


    }
}
</script>
<style scoped>
.table-header{
    display: flex;
    width: 100%;
    background-color: #666666;
    color: white;
    margin-top: 1rem;
    font-size: 80%;
}
.tz-table{
    padding-left: 1rem;
    padding-right: 1rem;
}
.table-content{
   
    width: 100%;
    background-color: white;
    color: #666666;
}
.table-row{
    display: flex;
    width: 100%;
    border-left: 1px solid #797979;
}
.table-row>div{
    width: 100%;
    border-right: 1px solid #797979;
    border-bottom: 1px solid #797979;
}
.table-header>div{
    width: 100%;
    border-right: 1px solid #797979;
    padding-top: .5rem;
    padding-bottom: .5rem;
}
#position{
    width: 76rem;
    min-height: 420px;
}
#profit{
     min-height: 420px;
}

.comp-info{
    width: 100%;
    background-color: #0264d2;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: .5rem;
    padding-bottom: .5rem;
}
.comp-info-title{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.portrait{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
.portrait>div{
    width: 57rem;
    min-height: 420px;
    background: white;
    margin: 1rem;
}
.portrait_header{
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.portrait_header>div:nth-child(1){
    font-weight: bold;
    font-size: 110%;
}
.portrait_header img{
    margin-right: 1rem;
}
.comp-info-content{
    display: flex;
    width: 100%;
}
.comp-info-content>div{
    width: 33%;
    display: flex;
    margin-top: 1rem;
}
.comp-info-content>div>img{
    margin-right: .3rem;
}
.member-info{
    width: 48%;
    text-align: right;
    display: flex;
    justify-content: end;
}
.member-info div{
    margin-right: 1rem;
    vertical-align: middle;
}
.tz-bold{
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/system/portrait.vue